import type { SortState } from '../../SortArrow/constants';
import { changeSortStateMap } from '../../SortArrow/constants';

export const changeSortState = (sortState: SortState): SortState => {
  return changeSortStateMap[sortState];
};
